import React from 'react'
import changeFileExtension from '@/lib/filename-extension-modifier'
import { string, object, bool, shape } from 'prop-types'
import { EventArticleSplitHero } from '@/component/Primitive/Events'

const EventArticleSplitHeroWidget = ({
  eventArticle,
  eventUmbrella,
  ...other
}) => {
  const { images } = eventArticle
  const fullUrlPath =
    'events/' +
    eventUmbrella?.slug +
    '/' +
    eventUmbrella?.event?.slug +
    '/' +
    eventArticle.eventBaseSlug +
    '/' +
    eventArticle.slug

  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]
  const largeSrcSet = [
    {
      width: 668,
      src: changeFileExtension(getImage('hero', 'landscape', 668)?.url, 'webp')
    },
    {
      width: 1336,
      src: changeFileExtension(getImage('hero', 'landscape', 1336)?.url, 'webp')
    }
  ]
  const smallSrcSet = [
    {
      width: 320,
      src: changeFileExtension(getImage('hero', 'landscape', 320)?.url, 'webp')
    },
    {
      width: 668,
      src: changeFileExtension(getImage('hero', 'landscape', 668)?.url, 'webp')
    }
  ]

  const image = {
    desktop: {
      srcSet: largeSrcSet,
      alt: 'Event Article Image',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('hero', 'landscape', 668)?.url
    },
    mobile: {
      srcSet: smallSrcSet,
      alt: 'Event Article Image',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('hero', 'landscape', 320)?.url
    }
  }
  return (
    <EventArticleSplitHero
      image={image}
      eventArticle={eventArticle}
      fullUrlPath={fullUrlPath}
      {...other}
    />
  )
}

EventArticleSplitHeroWidget.propTypes = {
  title: string,
  theme: string,
  inverse: bool,
  images: object,
  eventArticle: shape({
    headline: string,
    sell: string,
    slug: string,
    images: object
  }),
  eventUmbrella: shape({
    slug: string
  })
}

export default EventArticleSplitHeroWidget
